<template>
  <generic-popup
    v-model="dialog"
    :title="$t('title')"
    width="420"
  >
    <template #content>
      <div class="create-lists-info-content">
        <p class="nds-text-p-big">
          {{ $t('instruction') }}
        </p>

        <checkbox-element
          v-model="hide_popup"
          :label="$t('dont_show_popup_information')"
          @change="savePopupState()"
        />
      </div>
    </template>

    <template #actions>
      <button-element
        :text="$t('go_to_advanced_search')"
        width="100%"
        @click="goToAdvancedSearch()"
      />
    </template>
  </generic-popup>
</template>

<script>
import { MY_LIST_CONSTANTS } from '@/constants';

import ButtonElement from '@/components/elements/ButtonElement.vue';
import CheckboxElement from '@/components/elements/CheckboxElement.vue';
import GenericPopup from '@/components/elements/GenericPopup.vue';

function parseStoredPopupState(raw_value) {
  if (raw_value === null || raw_value === undefined) {
    return false;
  }

  try {
    return JSON.parse(raw_value) === true;
  } catch {
    return raw_value === 'true';
  }
}

export function getMyListsInfoPopupHidden() {
  const raw_value = localStorage.getItem(MY_LIST_CONSTANTS.INFO_POPUP_STORAGE_KEY)
    ?? localStorage.getItem(MY_LIST_CONSTANTS.INFO_POPUP_STORAGE_KEY_FALLBACK);

  return parseStoredPopupState(raw_value);
}

export function setMyListsInfoPopupHidden(hidden) {
  localStorage.setItem(
    MY_LIST_CONSTANTS.INFO_POPUP_STORAGE_KEY,
    JSON.stringify(hidden)
  );
}

export default {
  name: 'CreateListsInfoPopup',
  components: {
    ButtonElement,
    CheckboxElement,
    GenericPopup,
  },
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    modelValue: {
      default: false,
      type: Boolean,
    },
  },
  emits: [
    'confirm',
    'update:modelValue',
  ],
  data: () => ({
    hide_popup: false,
  }),
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
  watch: {
    modelValue(value) {
      if (value) {
        this.hide_popup = getMyListsInfoPopupHidden();
      }
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
    goToAdvancedSearch() {
      this.$emit('confirm');
      this.close();
    },
    savePopupState() {
      setMyListsInfoPopupHidden(this.hide_popup);
    },
  },
};
</script>

<style lang="scss" scoped>
.create-lists-info-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

:deep(.actions) {
  width: 100%;
}
</style>

<i18n src="@/locales/components/elements/my-lists/create-lists-info-popup.json"></i18n>
